var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDropDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    transform: "translate(-331 -243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    transform: "translate(-37.471 -132.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_215",
    d: "M0 0H10V10H0z",
    className: "cls-1",
    transform: "translate(375.471 382.471)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    transform: "translate(375.471 385.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    fill: "#2a374d",
    stroke: "#2a374d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.88 10.847L1.293 6.26l.967-.967 3.62 3.62 3.62-3.62.967.967z",
    transform: "translate(-1.293 -5.293)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_537",
    d: "M0 0H24V24H0z",
    className: "cls-1",
    transform: "translate(331 243)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropDown);
export default __webpack_public_path__ + "static/media/icon_drop_down.987c2bb5bc1e0ee8398de76969c13ad8.svg";
export { ForwardRef as ReactComponent };